module.exports = __webpack_public_path__ + "media/images/ph4-b1bcee13481bebf6299fe9ed3fb01ec0.png";